module.exports = __webpack_public_path__ + "static/greenisland2021_mainvideo-s-7e4b66d727e3d7f2d9d12fed47e690c6.mp4";